import { render, staticRenderFns } from "./areaPasswordForgotten.vue?vue&type=template&id=49984313&scoped=true&"
import script from "./areaPasswordForgotten.vue?vue&type=script&lang=js&"
export * from "./areaPasswordForgotten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49984313",
  null
  
)

export default component.exports